export default [
    //FOR Branch User to View the PO========================================================================
    {
        key: "viewPOSubmittedToMD",
        status: "Submitted To MD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Purchase Orders To Close",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list", 
                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "viewPOApproveMD",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Purchase Orders To Close",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list", 
                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
  //------------------------------------------------------------------------------------------------------
    //FOR FINANCE MANAGER===============================================================================

    {
        key: "PO Pending Approval",
        status: "PO Pending Approval",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,   //this is unique to PR data
        invoiceTitle: "PO Pending For Approval",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "PO Submitted To MD",
        status: "Submitted To MD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Approved Purchase Orders",
 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "poApprovedByMD",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Approved Purchase Orders",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "PORejectedByMD",
        status: "PO Rejected By MD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Rejected Purchase Orders",
        showPOPreview: true,
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "poToClose",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Purchase Orders To Close",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list", 
                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "CLOSED PO",
        status: "CLOSED PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "CLOSED Purchase Orders",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },


    //------------------------------------------------------------------------------------------
    //FOR Managing Director========================================================================

    {
        key: "submittedToMD",
        status: "Submitted To MD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Pending PO",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "APPROVED PO",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        showPrintButton: true,
        invoiceTitle: "Approved PO", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "PO Rejected By MD",
        status: "PO Rejected By MD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        invoiceTitle: "Rejected PO", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "poApprovedByMDForRevised",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        showPrintButton: true,
        invoiceTitle: "Approved PO", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            }, 
         
           
        ]

    },
 
    {
        key: "poRevised",
        status: "Approved PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        showPrintButton: true,
        invoiceTitle: "Approved PO", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            },
           
        ]

    },
    {
        key: "canceledPO",
        status: "Cancel PO",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        showPOPreview: true,
        showPrintButton: true,
        invoiceTitle: "Approved PO", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            }, 
        ]

    },

] 